export default "__VITE_ASSET__70c289cd__"